import React from 'react'
// import { Affix } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import drillYellow from 'image/version/drill-yellow.png'
import drillBlue from 'image/version/drill-blue.png'
import { isGlobalAuthVersion } from 'meinian-package/src/utils/auth'
import styles from './index.module.less'

const Exist = () => {
  return <Icon type="m-xiaoyan" style={{ fontSize: '24px', color: '#D39D53' }} />
}

const NotExist = () => {
  return <Icon type="m-guanbi" style={{ fontSize: '24px', color: 'var(--m-text-4)' }} />
}

export default () => {
  return <div className={styles['mn-version-control']}>
    <section className="mn-version-control-main">
      <div className="mn-version-control-main-title">选择适合您的美念版本</div>
      <div className="mn-version-control-main-version-table-wrap">

        <div className="mn-version-control-main-version-table-thead">
          <div style={{ width: '399px', background: '#FFFFFF' }} className="header-item">
            <div>
              <div className="main-title">功能对比</div>
              <div className="main-sub-title">开通专业版可享全部功能</div>
            </div>
          </div>
          <div style={{ width: '300px', background: 'linear-gradient(226deg, #FEFAF2 0%, #FCF4EA 100%)' }} className="header-item">
            <div>
              <div className="main-title">
                <img src={drillYellow} />专业版
              </div>
              {
                    isGlobalAuthVersion(150001) ? <div className="main-sub-title">联系销售开通</div> : <div className="main-sub-title">当前版本</div>
                  }
            </div>
          </div>
          <div style={{ width: '301px', background: 'linear-gradient(90deg, #F5F6FB 0%, #FBFCFD 100%)' }} className="header-item">
            <div>
              <div className="main-title">
                <img src={drillBlue} />基础版
              </div>
              {
                     isGlobalAuthVersion(150001) ? <div className="main-sub-title">当前版本</div> : <div className="main-sub-title">免费版本</div>
                  }
            </div>
          </div>
        </div>

        <table className="mn-version-control-main-version-table" style={{ marginTop: '-2px' }}>
          <thead className="mn-version-control-main-version-table-thead-1">
            <tr>
              <th colSpan="2" style={{ width: '400px' }} />
              <th style={{ width: '300px', background: 'linear-gradient(226deg, #FEFAF2 0%, #FCF4EA 100%)' }} />
              <th style={{ width: '300px', background: 'linear-gradient(90deg, #F5F6FB 0%, #FBFCFD 100%)' }} />
            </tr>
          </thead>
          <tbody className="mn-version-control-main-version-table-tbody">
            <tr className="tbody-col-1">
              <td rowSpan="8" style={{ width: '13%' }}>
                功能界面
              </td>
              <td>
                工作台
              </td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>灵感集</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>款式图库</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>样衣管理</td>
              <td><Exist /></td>
              <td><NotExist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>选款动态</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>选款助手</td>
              <td><Exist /></td>
              <td><NotExist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>智能分类</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>选款分析</td>
              <td><Exist /></td>
              <td><NotExist /></td>
            </tr>

            <tr className="tbody-col-1">
              <td rowSpan="8" className="tbody-col-1-td-bg">灵感集</td>
              <td>新建灵感集</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>新建灵感集数量</td>
              <td>不限</td>
              <td>20个</td>
            </tr>
            <tr className="tbody-col-2">
              <td>新建灵感集Pro</td>
              <td><Exist /></td>
              <td><NotExist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>单个灵感集款式数</td>
              <td>2000个</td>
              <td>2000个</td>
            </tr>
            <tr className="tbody-col-2">
              <td>新建子灵感集</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>单个灵感集新建子灵感集数</td>
              <td>不限</td>
              <td>5个</td>
            </tr>
            <tr className="tbody-col-2">
              <td>灵感集分析</td>
              <td><Exist /></td>
              <td><NotExist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>灵感集动态</td>
              <td><Exist /></td>
              <td><NotExist /></td>
            </tr>

            <tr className="tbody-col-1">
              <td rowSpan="3">协作</td>
              <td>多人协作</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>款式审核</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>审核层级自定义</td>
              <td><Exist /></td>
              <td><NotExist /></td>
            </tr>

            <tr className="tbody-col-1">
              <td rowSpan="11" className="tbody-col-1-td-bg">款式</td>
              <td>站内采集款式</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>站外采集款式（采集插件）</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>上传款式</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>单日款式下载数</td>
              <td>不限</td>
              <td>200个</td>
            </tr>
            <tr className="tbody-col-2">
              <td>款式单次批量下载数</td>
              <td>不限</td>
              <td>50个</td>
            </tr>
            <tr className="tbody-col-2">
              <td>上传/采集款式数</td>
              <td>不限</td>
              <td>不限</td>
            </tr>
            <tr className="tbody-col-2">
              <td>款式相似推荐</td>
              <td><Exist /></td>
              <td><NotExist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>编辑/导出制版单</td>
              <td><Exist /></td>
              <td><NotExist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>自定义款式属性</td>
              <td><Exist /></td>
              <td><NotExist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>款式的社交功能（包括评论/批注）</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>单日报表导出次数</td>
              <td>不限</td>
              <td>5次</td>
            </tr>

            <tr className="tbody-col-1">
              <td rowSpan="2">样衣</td>
              <td>上传/生成样衣</td>
              <td><Exist /></td>
              <td><NotExist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>样衣流程自定义</td>
              <td><Exist /></td>
              <td><NotExist /></td>
            </tr>

            <tr className="tbody-col-1">
              <td rowSpan="2" className="tbody-col-1-td-bg">智能打标</td>
              <td>智能打标</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
            <tr className="tbody-col-2">
              <td>单日智能打标数量（针对上传图）</td>
              <td>不限</td>
              <td>20张</td>
            </tr>

            <tr className="tbody-col-1">
              <td>选款分析</td>
              <td>款式查重</td>
              <td><Exist /></td>
              <td><NotExist /></td>
            </tr>

            <tr>
              <td className="tbody-col-1-td-bg" />
              <td>邀请非团队成员加入</td>
              <td><Exist /></td>
              <td><Exist /></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </div>
}
